import formatCurrency from '../modules/formatCurrency';

const paymentConfirmationInProgress = {
    imageUrl: '/images/hourglass.gif',
    imageHeight: 150,
    title: 'Payment confirmation in progress',
    html:  `<ul class="v-card__text" style="text-align: left;">
        <li>Please make sure you sent complete payment to the correct account.</li>
        <li>However, if you made complete payment to the correct account, then perhaps your payment is still processing and is yet to be received.</li>
        <li>If this error still persists after two hours and you made complete payment to the correct account, then please contact help & support for assistance.</li>
        <li>If you accidentally made incomplete payment or made payment to the wrong account, then quickly contact help & support for assistance.</li>
        <br>
        <p>Thank you<p>
    </ul>`,
};

function getPaymentReceivedMessage(match) {
    const { matcherRecipient } = match;
    if (!matcherRecipient) {
        return null;
    }

    if (!matcherRecipient.recipient) {
        return null;
    }

    const { recipientInfo } = matcherRecipient.recipient;
    if (!recipientInfo) {
        return null;
    }

    const {
        name,
        payment_type: paymentType,
    } = recipientInfo;

    const paymentTypeId = paymentType ? paymentType.id : null;
    let destination;
    if (paymentTypeId === 1) {
        destination = 'bank account';
    }
    if (paymentTypeId === 3) {
        destination = 'mobile money account';
    }

    return `Congratulations! Now we have confirmed receipt of your payment,
        ${match.poster_currency} ${formatCurrency(match.poster_amount)}
        will be deposited into ${name}'s ${destination}.
        This transfer will be completed within 24 hours. Thank you.`;
}

class TransactionService {
    static async validate(vm, match, payload = {}) {
        const matchId = match.id;

        try {
            const response = await Vue.backendApi().order().validateTransaction(matchId, payload);

            const {
                matcher_payment_completed_at: matcherPaymentCompletedAt,
                probably_paid: probablyPaid,
                type,
            } = response.data;

            if (matcherPaymentCompletedAt) {
              vm.$swal({
                  type: 'success',
                  title: 'Payment received',
                  text: getPaymentReceivedMessage(match),
              });
            } else if(type === 'hybrid' && probablyPaid) {
              vm.$swal({
                  type: 'warning',
                  title: 'Payment Processing',
                  html: 'Thank you for your payment. We will notify you as soon as we confirm receipt of your payment. This should not take more than an hour.',
              });
            } else {
              vm.$swal(paymentConfirmationInProgress);
            }
        } catch (err) {
            const error = err.toUpperCase();

            if (error === 'PAYMENT_NOT_RECEIVED') {
                vm.$swal(paymentConfirmationInProgress);
            } else if (error === 'PAYMENT_RECEIVED') {
                vm.$swal({
                    type: 'success',
                    title: 'Payment Received',
                    text: getPaymentReceivedMessage(match),
                });
            } else if (error === 'PB_BANK_IS_DOWN' || error === 'MATCHER_BANK_IS_DOWN') {
                vm.$swal({
                    type: 'warning',
                    customContainerClass: 'sad-face',
                    title: 'Oops! Bank Connection Is Down!',
                    text: `Sorry we are unable to confirm the receipt of
                        your payment at this time. Our bank connection is
                        down at this time. However, you need not to worry or
                        do anything extra. As soon as we re-establish connection,
                        we would confirm your payment and notify you of the
                        completion of this transaction. Please bear with us.
                        Thank you.`,
                });
            } else {
                vm.$swal({
                    type: 'warning',
                    title: err,
                });
            }

            throw err;
        }
    }
}

export default TransactionService;
